module.exports = __webpack_public_path__ + "static/media/ccs-pres.43e65c75.jpg";